<div class="milestone-tracking-section">

  <div class="max-w-7xl mx-auto px-3 mb-4">

    <h3 class="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
      <span class="bg-teal-100 text-teal-600 rounded p-1.5">
        <i class="pi pi-flag text-base"></i>
      </span>
      Milestone Tracking Table
    </h3>

    <div class="bg-white rounded-lg shadow overflow-hidden">

      <div class="overflow-x-auto max-h-[320px] overflow-y-auto">

        <table class="w-full text-sm">

          <!-- HEADER -->
          <thead class="bg-blue-950 sticky top-0 z-10">

            <tr>
              <th class="px-2 py-2 text-white text-left sortable" (click)="toggleSort('ser')">
                <span class="th-wrap"><span>S. No.</span><i [class]="getSortIcon('ser')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-left sortable" (click)="toggleSort('challenge')">
                <span class="th-wrap"><span>Challenge</span><i [class]="getSortIcon('challenge')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-left sortable" (click)="toggleSort('firmDetails')">
                <span class="th-wrap"><span>Firm Details</span><i [class]="getSortIcon('firmDetails')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="toggleSort('ms_00')">
                <span class="th-wrap center"><span>MS 00</span><i [class]="getSortIcon('ms_00')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="toggleSort('ms_01')">
                <span class="th-wrap center"><span>MS 01</span><i [class]="getSortIcon('ms_01')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="toggleSort('ms_02')">
                <span class="th-wrap center"><span>MS 02</span><i [class]="getSortIcon('ms_02')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="toggleSort('ms_03')">
                <span class="th-wrap center"><span>MS 03</span><i [class]="getSortIcon('ms_03')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="toggleSort('ms_04')">
                <span class="th-wrap center"><span>MS 04</span><i [class]="getSortIcon('ms_04')"></i></span>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="toggleSort('ms_05')">
                <span class="th-wrap center"><span>MS 05</span><i [class]="getSortIcon('ms_05')"></i></span>
              </th>
            </tr>

            <!-- FILTER ROW -->
            <tr class="bg-gray-100">

              <th class="p-1">
                <input [(ngModel)]="filters.ser" (input)="applyFilter()" class="w-full border rounded px-1 text-xs">
              </th>

              <th class="p-1">
                <input [(ngModel)]="filters.challenge" (input)="applyFilter()" class="w-full border rounded px-1 text-xs">
              </th>

              <th class="p-1">
                <input [(ngModel)]="filters.firmDetails" (input)="applyFilter()" class="w-full border rounded px-1 text-xs">
              </th>

              <th class="p-1"><input [(ngModel)]="filters.ms_00" (input)="applyFilter()" class="w-full border rounded px-1 text-xs"></th>
              <th class="p-1"><input [(ngModel)]="filters.ms_01" (input)="applyFilter()" class="w-full border rounded px-1 text-xs"></th>
              <th class="p-1"><input [(ngModel)]="filters.ms_02" (input)="applyFilter()" class="w-full border rounded px-1 text-xs"></th>
              <th class="p-1"><input [(ngModel)]="filters.ms_03" (input)="applyFilter()" class="w-full border rounded px-1 text-xs"></th>
              <th class="p-1"><input [(ngModel)]="filters.ms_04" (input)="applyFilter()" class="w-full border rounded px-1 text-xs"></th>
              <th class="p-1"><input [(ngModel)]="filters.ms_05" (input)="applyFilter()" class="w-full border rounded px-1 text-xs"></th>

            </tr>

          </thead>

          <!-- BODY -->

          <tbody class="divide-y divide-gray-200">

            <tr *ngFor="let item of paginatedData; let i = index"
                [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-slate-200': i % 2 !== 0 }">

              <td class="px-2 py-1">{{ item.ser || (i + 1) }}</td>
              <td class="px-2 py-1">{{ item.challenge || 'N/A' }}</td>
              <td class="px-2 py-1">{{ item.firmDetails || 'N/A' }}</td>
              <td class="px-2 py-1 text-center">{{ item.ms_00 || '-' }}</td>
              <td class="px-2 py-1 text-center">{{ item.ms_01 || '-' }}</td>
              <td class="px-2 py-1 text-center">{{ item.ms_02 || '-' }}</td>
              <td class="px-2 py-1 text-center">{{ item.ms_03 || '-' }}</td>
              <td class="px-2 py-1 text-center">{{ item.ms_04 || '-' }}</td>
              <td class="px-2 py-1 text-center">{{ item.ms_05 || '-' }}</td>

            </tr>

          </tbody>

        </table>

      </div>

      <!-- PAGINATION -->

      <div class="flex justify-between items-center p-3 bg-gray-100 border-t text-sm">

        <div>
          Showing {{startEntry}} to {{endEntry}} of {{filteredMilestoneData.length}} entries
        </div>

        <div class="flex items-center gap-2">

          <button class="px-2 py-1 border rounded" (click)="changePage(1)">«</button>

          <button class="px-2 py-1 border rounded" (click)="changePage(currentPage-1)">‹</button>

          <button *ngFor="let page of pages"
                  (click)="changePage(page)"
                  class="px-3 py-1 rounded-full"
                  [ngClass]="{
                    'bg-blue-200 text-blue-900': page === currentPage,
                    'bg-white border': page !== currentPage
                  }">
            {{page}}
          </button>

          <button class="px-2 py-1 border rounded" (click)="changePage(currentPage+1)">›</button>

          <button class="px-2 py-1 border rounded" (click)="changePage(totalPages)">»</button>

        </div>

        <div>
          <select [(ngModel)]="pageSize"
                  (change)="changePageSize()"
                  class="border rounded px-2 py-1">

            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{size}}
            </option>

          </select>
        </div>

      </div>

    </div>

  </div>

</div>